import { keyBy } from 'lodash';
import Interval from '../../../../../src/component/helpers/IntervalCallApi';
import topVolumeService, {
  default as topMoverService,
} from '../../../../core/services/Market/TopMover/TopMoverService';
import reducerRegistry from '../../../helpers/ReducerRegistry';
import Const from '../Const';
import { handleExport } from '../../../helpers/HandleExport';

const REDUCER_NAME = 'TOP_VOLUME:OVERVIEW:';
const FETCH_LIST_OVERVIEW_TABLE = `${REDUCER_NAME}FETCH_LIST_OVERVIEW_TABLE`;
const SUBSCRIBE_REALTIME_TICK = `${REDUCER_NAME}SUBSCRIBE_REALTIME_TICK`;
const UPDATE_CHART_IMAGE = `${REDUCER_NAME}UPDATE_CHART_IMAGE`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const CHANGE_SORT_STATE = `${REDUCER_NAME}CHANGE_SORT_STATE`;

export {
  REDUCER_NAME,
  fetchListOverviewTable,
  cancelFetchListOverviewTable,
  subscribeRealtimeTickTopVolume,
  fetchChartImage,
  changeSortState,
  downloadTopVolume,
};

function cancelFetchListOverviewTable() {
  return () => {
    Interval.cancel('TopVolume');
  };
}

function changeSortState(sortState) {
  return {
    type: CHANGE_SORT_STATE,
    payload: sortState,
  };
}

function fetchListOverviewTable(filter = 'All') {
  return dispatch => {
    Interval.fetch(
      'TopVolume',
      dispatch,
      () => {
        dispatch(setLoading(true));
        return topMoverService.getDataTopVolumeOverview({
          ComGroupCode: filter,
        });
      },
      response => {
        dispatch(setLoading(false));
        if (response) {
          const listDataOverview = response.items || [];
          dispatch({
            type: FETCH_LIST_OVERVIEW_TABLE,
            payload: {
              listDataOverview,
            },
          });
        }
      },
      Const.topVolumeInterval,
      err => dispatch(setLoading(false)),
    );
  };
}

function subscribeRealtimeTickTopVolume(data) {
  return {
    type: SUBSCRIBE_REALTIME_TICK,
    payload: {
      data,
    },
  };
}

function fetchChartImage(organCode, theme) {
  return dispatch => {
    topMoverService
      .getTopVolumeChartImage({
        organCode,
        theme,
      })
      .then(({ items }) => {
        dispatch({
          type: UPDATE_CHART_IMAGE,
          payload: {
            organCode,
            image: items ? items[0] : '',
          },
        });
      });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function downloadTopVolume(filter, tab, fileName = 'export-file') {
  return dispatch => {
    topVolumeService
      .downloadTopVolume({ ComGroupCode: filter, Screen: Const.screen[tab] })
      .then(response => {
        handleExport(response, fileName);
      });
  };
}

const initialState = {
  listDataOverviewTicker: [],
  listObjectDataOverviewByTicker: {},
  images: {},
  component: {},
  isLoading: false,
  sortState: {},
};

function reducer(globalState = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...globalState,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_LIST_OVERVIEW_TABLE:
      const listObjectDataOverviewByTicker = keyBy(
        action.payload.listDataOverview,
        'organCode',
      );
      const listDataOverviewTicker = action.payload.listDataOverview.map(
        item => item.organCode,
      );
      return {
        ...globalState,
        listDataOverviewTicker,
        listObjectDataOverviewByTicker,
      };

    case SUBSCRIBE_REALTIME_TICK:
      const listObjectDataOverviewByTickerNew = {
        ...globalState.listObjectDataOverviewByTicker,
      };

      action.payload.data.forEach(item => {
        if (listObjectDataOverviewByTickerNew[item.organCode]) {
          const tickerItem = {
            ...listObjectDataOverviewByTickerNew[item.organCode],
          };

          if (tickerItem) {
            tickerItem.volume = item.totalMatchVolume;
            tickerItem.price = item.matchPrice;
            tickerItem.percentPriceChange = item.percentPriceChange;
            tickerItem.tradingDate = item.tradingDate;
            tickerItem.performance.percentPriceChange1Day =
              item.percentPriceChange;
          }
          listObjectDataOverviewByTickerNew[item.organCode] = tickerItem;
        }
      });

      return {
        ...globalState,
        listObjectDataOverviewByTicker: listObjectDataOverviewByTickerNew,
      };

    case UPDATE_CHART_IMAGE:
      return {
        ...globalState,
        images: {
          ...globalState.images,
          [action.payload.organCode]: action.payload.image,
        },
      };

    case CHANGE_SIZE_COMPONENT:
      return {
        ...globalState,
        component: action.payload,
      };

    case SET_LOADING:
      return {
        ...globalState,
        isLoading: action.payload,
      };

    case CHANGE_SORT_STATE:
      return {
        ...globalState,
        sortState: action.payload,
      };

    default:
      return globalState;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
